import ScrimGeneralModal from './ScrimGeneralModal';

export default ScrimGeneralModal;
